import { RiTimeLine } from "react-icons/ri";
import styled from "styled-components";

import { Flex, Text } from "rebass/styled-components";

type TCountDownRendererProps = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  color: string;
  variant?: string;
  size?: "small" | "large";
  showEndsIn?: boolean;
  showIcon?: boolean;
};

export const CountDownRenderer = ({
  days,
  hours,
  minutes,
  seconds,
  color,
  variant = "text.labelMedium",
  showEndsIn = true,
  showIcon = false,
}: TCountDownRendererProps) => {
  const timeString = `${days < 10 ? "0" : ""}${days}:${
    hours < 10 ? "0" : ""
  }${hours}:${minutes < 10 ? "0" : ""}${minutes}:${
    seconds < 10 ? "0" : ""
  }${seconds}`;

  return (
    <Flex
      justifyContent={["center", "center", "center", "space-between"]}
      flexDirection={"column"}
    >
      <CountdownDate
        flexDirection={"row"}
        justifyContent="start"
        alignItems="center"
        style={{ gap: showIcon ? 4 : 0 }}
      >
        {showIcon && <ClockIcon color={color} />}
        <Text color={"ice"} variant={variant} fontWeight={600}>
          {showEndsIn && (
            <Text
              color={color}
              variant={variant}
              fontWeight={600}
              style={{ display: "inline" }}
            >
              Ends in{" "}
            </Text>
          )}
          {timeString}
        </Text>
      </CountdownDate>
    </Flex>
  );
};

const CountdownDate = styled(Flex)`
  color: ${({ theme }) => theme.colors.ice};
  position: relative;
  z-index: 2;
`;

const ClockIcon = styled(RiTimeLine)`
  height: 20px;
  width: 20px;
`;
